// Info: Import NPM Dependancies
import { AbortController } from 'node-abort-controller'

export function defineCancelApiObject(apiObject: any): any {
    const cancelApiObject: any = {}
    Object.getOwnPropertyNames(apiObject).forEach((apiPropertyName: string) => {
        const cancellationControllerObject: any = {
            controller: undefined,
        }
        cancelApiObject[apiPropertyName] = {
            handleRequestCancellation: () => {
                if (cancellationControllerObject.controller) {
                    cancellationControllerObject.controller.abort()
                }
                cancellationControllerObject.controller = new AbortController()
                return cancellationControllerObject.controller
            },
        }
    })
    return cancelApiObject
}

